<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">El formulario se ha realizado con éxito. <i>¡Gracias! </i>
      </h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>


<!--      <div class="has-text-centered pb-6">-->
<!--        <h1 class="is-size-2 pb-5">Formulario Bodegas</h1>-->
<!--        <p class="pb-3">-->
<!--          Bienvenidos. En este formulario podréis hacernos llegar toda la información relativa a vuestra Bodega. El-->
<!--          proceso os llevará unos 10 minutos y os solicitaremos vuestra información corporativa en castellano e inglés-->
<!--          asimismo como algunas fotografías que os recomendamos tengáis ya seleccionadas. </p>-->
<!--        <p> Disponéis hasta el próximo día-->
<!--          <strong>31 de Marzo</strong> para enviar vuestra información. Para cualquier duda, podéis contactar con-->
<!--          nosotros en: <a-->
<!--              style="color: #0a0a0a;text-decoration: underline" href="mailto:production@chelseaco.agency">production@chelseaco.agency</a>.-->
<!--        </p>-->
<!--        Gracias por vuestra colaboración.-->

<!--      </div>-->

      <div class="field">
        <label class="label">Nombre de la bodega <span class="required">*</span>
        </label>
        <div class="control">
          <input v-model="nombreDeBodega" class="input" type="text">
          <div class="has-text-error-message" v-if="v$.nombreDeBodega.$error">{{ nec }}</div>
          <div class="help">Incluir aquí el nombre que quieres que aparezca en la web. No es necesario incluir siglas
            que referencien a la sociedad como "S.A" o “S.L”
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Nombre oficial registrado en El Consejo Regulador <span class="required">*</span>
        </label>
        <div class="control">
          <input v-model="nombreOficial" class="input" type="text">
          <div class="has-text-error-message" v-if="v$.nombreOficial.$error">{{ nec }}</div>

        </div>


      </div>


      <label class="label">Tipo de bodega <span class="required">*</span>
      </label>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox" type="checkbox" name="exampleRtlCheckbox" v-model="tipo1">
        <label for="exampleRtlCheckbox">Crianza y almacenista</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox1" type="checkbox" name="exampleRtlCheckbox1"
               v-model="tipo2">
        <label for="exampleRtlCheckbox1">Crianza y expedición</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox2" type="checkbox" name="exampleRtlCheckbox2"
               v-model="tipo3">
        <label for="exampleRtlCheckbox2">Bodegas y producción</label>
        <div class="has-text-error-message" v-if="v$.type3.$error">Hay que seleccionar un tipo de bodega</div>

      </div>

      <label class="label">IMAGEN DE LA BODEGA (1)
      </label>
      <div class="uploader uploader1">
        <file-upload v-show="files.length == 0"

                     input-id="file1"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file1"
                     v-model="files"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader1'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile"


        >
          <div>
            <div class="is-size-6 has-text-weight-bold">
              Prueba a arrastrar una imagen aquí o haz click para seleccionar el archivo

            </div>
            <div class="is-size-7 ">
              Las imágenes son de suma importancia y deben tener un tamaño medio o grande para poder garantizar una integración correcta con el diseño. Recomendamos fotografías no muy oscuras y en la que puedan distinguirse los detalles.  <strong>Peso máximo: 4MB</strong>
            </div>
          </div>

        </file-upload>
        <div v-if="files.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-error-message" v-if="v$.f1.$error">Hay que subir un archivo</div>



      <label class="label">IMAGEN DE LA BODEGA (2)
      </label>

      <div class="uploader uploader2">
        <file-upload v-show="files2.length == 0"
                     input-id="file2"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file2"
                     v-model="files2"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader2'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile2"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">
              Prueba a arrastrar una imagen aquí o haz click para seleccionar el archivo

            </div>
            <div class="is-size-7 ">
              Las imágenes son de suma importancia y deben tener un tamaño medio o grande para poder garantizar una integración correcta con el diseño. Recomendamos fotografías no muy oscuras y en la que puedan distinguirse los detalles.  <strong>Peso máximo: 4MB</strong>
            </div>
          </div>

        </file-upload>
        <div v-if="files2.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files2.length ? files2[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files2[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files2=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="has-text-error-message" v-if="v$.f2.$error">Hay que subir un archivo</div>



      <label class="label">Dirección para contactos generales</label>

      <div class="fields ">
        <div class="columns">

          <div class="column is-4">

            <div class="control">
              <div class="select">
                <select v-model="calleT">
                  <option value="Calle">Calle</option>
                  <option value="Avenida">Avenida</option>
                  <option value="Carretera">Carretera</option>
                  <option value="Plaza">Plaza</option>
                  <option value="Puerta">Puerta</option>
                  <option value="Puerta Avenida">Puerta Avenida</option>
                  <option value="Pol. Industrial">Pol. Industrial</option>
                </select>
              </div>
            </div>
          </div>
          <div class="column is-4">

            <div class="control">
              <input v-model="calle" class="input" type="text" placeholder="Nombre de la calle">
              <span class="has-text-error-message" v-if="v$.calle.$error">{{ nec }}</span>
            </div>
          </div>
          <div class="column is-4">
            <div class="control">
              <input v-model="callenum" class="input" type="text" placeholder="Núm, Km, S/N, etc">
              <span class="has-text-error-message" v-if="v$.callenum.$error">{{ nec }}</span>
            </div>
          </div>

        </div>
      </div>


      <div class="field">
        <label class="label">Población <span class="required">*</span></label>
        <div class="control">
          <input v-model="pueblo" class="input" type="text">
          <div class="has-text-error-message" v-if="v$.pueblo.$error">{{ nec }}</div>
        </div>
      </div>


      <div class="columns">
        <div class="column is-6">
          <div class="field">
            <label class="label">Código Postal <span class="required">*</span></label>
            <div class="control">
              <input v-model="cp" class="input" type="text">
              <div class="has-text-error-message" v-if="v$.cp.$error">{{ cpe }}</div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Zona <span class="required">*</span></label>
            <div class="select">
              <select v-model="zona">
                <option value="Jerez de la Frontera">Jerez de la Frontera</option>
                <option value="El Puerto de Santa María">El Puerto de Santa María</option>
                <option value="Sanlúcar de Barrameda">Sanlúcar de Barrameda</option>
                <option value="Chipiona">Chipiona</option>
                <option value="Chiclana de la Frontera">Chiclana de la Frontera</option>
                <option value="Lebrija">Lebrija</option>
                <option value="Rota">Rota</option>
                <option value="Trebujena">Trebujena</option>
                <option value="Puerto Real">Puerto Real</option>
              </select>
            </div>
            <div class="has-text-error-message" v-if="v$.zona.$error">{{ nec }}</div>
          </div>
        </div>
      </div>


      <div class="field">
        <label class="label">Email <span class="required">*</span></label>
        <div class="control">
          <input v-model="email" type="email" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.email.$error">{{ mail }}</div>

      </div>


      <div class="field">
        <label class="label">Teléfono <span class="required">*</span></label>
        <div class="control">
          <input v-model="telefono" type="tel" class="input" >
          <div class="has-text-error-message" v-if="v$.telefono.$error">{{ tel }}</div>
        </div>
      </div>


      <div class="field">
        <label class="label">Sitio Web</label>
        <div class="control">
          <input v-model="sitioWeb" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.sitioWeb.$error">{{ url }}</div>

        </div>
      </div>


      <div class="field">
        <label class="label">Tienda Online</label>
        <div class="control">
          <input v-model="tiendaOnline" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.tiendaOnline.$error">{{ url }}</div>

        </div>
      </div>


      <div class="field pt-5">
        <input v-model="enoturismo" class="is-checkradio" id="exampleRtlCheckbox22" type="checkbox"
               name="exampleRtlCheckbox22"
               checked="checked">
        <label class="label" for="exampleRtlCheckbox22">Enoturismo</label>
      </div>


      <div v-show="enoturismo" class="field pt-5">
        <input v-model="enoturismo2" class="is-checkradio" id="exampleRtlCheckbox52" type="checkbox"
               name="exampleRtlCheckbox22"
               checked="checked">
        <label class="label" for="exampleRtlCheckbox52">Usar una dirección diferente para enoturismo</label>
      </div>
      <div v-if="enoturismo2">
        <label class="label">INFORMACIÓN SOBRE VISITAS A LA BODEGA</label>


        <div class="fields ">
          <div class="columns">

            <div class="column is-4">

              <div class="control">
                <div class="select">
                  <div class="select">
                    <select v-model="calleVT">
                      <option value="Calle">Calle</option>
                      <option value="Avenida">Avenida</option>
                      <option value="Carretera">Carretera</option>
                      <option value="Plaza">Plaza</option>
                      <option value="Puerta">Puerta</option>
                      <option value="Puerta Avenida">Puerta Avenida</option>
                      <option value="Pol. Industrial">Pol. Industrial</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4">

              <div class="field">
                <div class="control">
                  <input v-model="calleV" type="text" class="input" placeholder="Nombre de la calle">
                  <div class="has-text-error-message" v-if="v$.calleV.$error">{{ nec }}</div>

                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="control">
                <input v-model="callenumV" class="input" type="text" placeholder="Núm, Km, S/N, etc">
                <div class="has-text-error-message" v-if="v$.callenumV.$error">{{ nec }}</div>

              </div>
            </div>

          </div>
        </div>


        <div class="field">
          <label class="label">Población (Visitas)</label>
          <div class="control">
            <input v-model="puebloV" class="input">
            <div class="has-text-error-message" v-if="v$.puebloV.$error">{{ nec }}</div>

          </div>
        </div>

        <div class="field">
          <label class="label">Código Postal </label>
          <div class="control">
            <input v-model="cpV" class="input" type="text">
            <div class="has-text-error-message" v-if="v$.cpV.$error">{{ cpe }}</div>


          </div>
        </div>


        <div class="field">
          <label class="label">Email (Visitas)</label>
          <div class="control">
            <input v-model="emailV" type="email" class="input">
            <div class="has-text-error-message" v-if="v$.emailV.$error">{{ mail }}</div>
          </div>
        </div>


        <div class="field">
          <label class="label">Teléfono (Visitas)</label>
          <div class="control">
            <input v-model="telefonoV" type="tel" class="input" placeholder="+34">
            <div class="has-text-error-message" v-if="v$.telefonoV.$error">{{ tel }}</div>

          </div>
        </div>


        <div class="field">
          <label class="label">Sitio Web (Visitas)</label>
          <div class="control">
            <input v-model="sitioWebV" type="url" class="input" placeholder="https://">
            <div class="has-text-error-message" v-if="v$.sitioWebV.$error">{{ url }}</div>

          </div>
        </div>
      </div>


      <div class="field">
        <label class="label">Instagram</label>
        <div class="control">
          <input v-model="instagram" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.instagram.$error">{{ url }}</div>

        </div>
      </div>


      <div class="field">
        <label class="label">Facebook</label>
        <div class="control">
          <input v-model="facebook" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.facebook.$error">{{ url }}</div>

        </div>
      </div>

      <div class="field">
        <label class="label">Twitter</label>
        <div class="control">
          <input v-model="twitter" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ url }}</div>

        </div>
      </div>

      <div class="field">
        <label class="label">Linkedin</label>
        <div class="control">
          <input v-model="linkedin" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.linkedin.$error">{{ url }}</div>

        </div>
      </div>


      <div class="field">
        <label class="label">YouTube</label>
        <div class="control">
          <input v-model="other" type="url" class="input" placeholder="https://">
        </div>
      </div>


      <div class="field">
        <label class="label">Texto descriptivo de la bodega (Español)<span class="required">*</span></label>
        <div class="control">
          <textarea v-model="descEs" class="textarea"></textarea>
          <div class="has-text-error-message" v-if="v$.descEs.$error">{{ nec }}</div>

        </div>
      </div>


      <div class="field">
        <label class="label">Texto descriptivo de la bodega (Inglés)<span class="required">*</span></label>
        <div class="control">
          <textarea v-model="descEn" class="textarea"></textarea>
                    <div class="has-text-error-message" v-if="v$.descEn.$error">{{ nec }}</div>

        </div>
      </div>

      <label class="label">Productos</label>
      <div v-for="(prod,i) in prods" class="columns">
        <div class="column is-5">
          <div class="select is-fullwidth"><select v-model="prod.type">

            <option value="Manzanilla">Manzanilla</option>
            <option value="Fino">Fino</option>
            <option value="Amontillado">Amontillado</option>
            <option value="Palo Cortado">Palo Cortado</option>
            <option value="Oloroso">Oloroso</option>
            <option value="Pale cream">Pale cream</option>
            <option value="Medium">Medium</option>
            <option value="Cream">Cream</option>
            <option value="Moscatel">Moscatel</option>
            <option value="Pedro Ximénez">Pedro Ximénez</option>
          </select></div>
        </div>
        <div class="column is-5">
          <input class="input" v-model="prod.name" placeholder="Nombre de producto">
        </div>
        <div class="column is-2">
          <button style="background: #D37700 !important; font-size: 14px; padding: 20px 0px;border: none" v-if="i>0"
                  class="button is-uppercase has-text-weight-bold is-fullwidth has-text-white" @click="removeProd(i)"
                  type="button">X
          </button>
        </div>
      </div>
      <div class="pb-5">
        <button style="background: #D37700 !important; font-size: 14px; padding: 20px 40px;border: none"
                v-if="prods.length<5"
                class="button is-info is-uppercase has-text-weight-bold" @click="addProd" type="button">Añadir más
          productos
        </button>
      </div>
      <div class="field">
        <input v-model="newsletter" class="is-checkradio" id="exampleRtlCheckbox6" type="checkbox"
               name="exampleRtlCheckbox2"
               checked="checked">
        <label for="exampleRtlCheckbox6">Suscríbame al newsletter</label>
      </div>

      <div class="field">
        <input v-model="toc" class="is-checkradio" id="exampleRtlCheckbox7" type="checkbox" name="exampleRtlCheckbox2"
               checked="checked">
        <label for="exampleRtlCheckbox7">Acepto la <a style="color: #D37700; text-decoration: underline"
                                                      href="https://www.sherry.wine/es/legal">totalidad de las
          condiciones</a> <span
            class="required">*</span></label>
        <div class="has-text-error-message" v-if="v$.toc.$error">{{ nec }}</div>

      </div>

      <div class="pt-5">
        <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">Enviar
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

export default {
  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Bodegas',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,

  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String
  },
  data() {
    return {

      files: [],
      files2: [],

      f1: null,
      f2: null,

      nec: "Este campo es necesario",
      mail: "Este campo tiene que ser un email",
      url: "Este campo tiene que ser un url",
      tel: "Este campo tiene que ser telefono",
      cpe: "Este campo tiene que un código postal",

      nombreDeBodega: '',
      nombreOficial: '',
      tipo1: false,
      tipo2: false,
      tipo3: false,

      callenum: '',
      calle: '',
      calleT: 'Calle',
      pueblo: '',
      cp: '',
      zona: 'Jerez de la Frontera',
      email: '',
      telefono: '',
      sitioWeb: '',

      callenumV: '',
      enoturismo: '',
      calleV: '',
      calleVT: 'Calle',
      cpV: '',
      puebloV: '',
      emailV: '',
      telefonoV: '',
      sitioWebV: '',

      tiendaOnline: '',

      prods: [
        {
          type: 'Manzanilla',
          name: ''
        }
      ],

      instagram: '',
      facebook: '',
      twitter: '',
      linkedin: '',
      other: '',

      descEs: '',
      descEn: '',
      toc: '',
      newsletter: '',

      success: false,
      enoturismo2: false,
      type3: false,

    };
  },
  validations() {

    function atLeastOne(value) {
      return this.tipo1 || this.tipo2 || this.tipo3;
    }

    return {
      f1:{required},
      f2:{required},
      enoturismo2: {$autoDirty: true},
      nombreDeBodega: {required},
      nombreOficial: {required},
      calle: {required},
      pueblo: {required},
      zona: {required},
      cp: {required, integer},
      email: {required, email},
      telefono: {required, integer},
      sitioWeb: {url},
      callenum: {required},
      calleV: {requiredIfCalleV: requiredIf(this.enoturismo2)},
      calleVT: {requiredIfCalleVT: requiredIf(this.enoturismo2)},
      callenumV: {requiredIfCallenumV: requiredIf(this.enoturismo2)},
      cpV: {requiredIfCpV: requiredIf(this.enoturismo2)},
      puebloV: {requiredIfPuebloV: requiredIf(this.enoturismo2)},
      emailV: {email, requiredIfEmailV: requiredIf(this.enoturismo2)},
      telefonoV: {requiredIfTelefonoV: requiredIf(this.enoturismo2), integer},
      sitioWebV: {url},
      tiendaOnline: {url},
      instagram: {url},
      facebook: {url},
      twitter: {url},
      linkedin: {url},
      other: {url},
      descEs: {required},
      descEn: {required},
      toc: {required},
      type3: {atLeastOne},
      prods: {
        $each: {
          name: {required},
        }
      }
    };
  },
  methods: {


    async inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file1.active) {
          this.$refs.file1.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },
    inputFile2(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file2.active) {
          this.$refs.file2.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },
    progress(newFile, oldFile) {
      // Upload progress
      if (newFile.progress !== oldFile.progress) {
        console.log('progress', newFile.progress, newFile);
      }

      // Upload error
      if (newFile.error !== oldFile.error) {
        console.log('error', newFile.error, newFile);
      }

      // Uploaded successfully
      if (newFile.success !== oldFile.success) {
        console.log('success', newFile.success, newFile);
      }
    },

    async submit() {
      const result = await this.v$.$validate();
      if (!result) {
        // notify user form is invalid
        this.scrollToClass('has-text-error-message');
        return;
      }

      const formData = {
        nombreDeBodega: this.nombreDeBodega,
        nombreOficial: this.nombreOficial,
        tipo1: this.tipo1,
        tipo2: this.tipo2,
        tipo3: this.tipo3,
        callenum: this.callenum,
        calle: this.calle,
        calleT: this.calleT,
        pueblo: this.pueblo,
        cp: this.cp,
        zona: this.zona,
        email: this.email,
        telefono: this.telefono,
        sitioWeb: this.sitioWeb,
        callenumV: this.callenumV,
        enoturismo: this.enoturismo,
        calleV: this.calleV,
        calleVT: this.calleVT,
        cpV: this.cpV,
        puebloV: this.puebloV,
        emailV: this.emailV,
        telefonoV: this.telefonoV,
        sitioWebV: this.sitioWebV,
        tiendaOnline: this.tiendaOnline,
        prods: this.prods,
        instagram: this.instagram,
        facebook: this.facebook,
        twitter: this.twitter,
        linkedin: this.linkedin,
        other: this.other,
        descEs: this.descEs,
        descEn: this.descEn,
        toc: this.toc,
        newsletter: this.newsletter,
        f1: this.files[0].response.id,
        f2: this.files2[0].response.id,
        waglocale: this.waglocale

      };

      axios.post("/api/bodega/", formData)
          .then((res) => {
            console.log(res);
            this.success = true;
          })
          .catch((err) => {
            alert("Ha habido un error, contacta con soporte");
          });

    },
    addProd() {
      this.prods.push({type: 'Manzanilla', name: ''});
    },
    removeProd(i) {
      this.prods.splice(i, 1);
    },
    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },
    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("El archivo tiene que ser png o jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        alert("El archivo tiene que tener menos de 4 MB");
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },

  },
  watch: {
      files: {
        handler: function (files, oldVal) {
          if(files.length > 0 && files[0].response && files[0].response.id){
            this.f1 = files[0].response.id
            return
          }
          this.f1 = null

        },
        deep: true
      },
      files2: {
        handler: function (files, oldVal) {
          if(files.length > 0 && files[0].response && files[0].response.id){
            this.f2 = files[0].response.id
            return
          }
          this.f2 = null
        },
        deep: true
      }
    },
  mounted(){
    console.log("lang",this.$i18n)
    this.$i18n.locale = this.lang
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}

</style>